import React from "react";

/**
 * Section heading used by every section: eyebrow, title, optional lead line and text.
 * Wrap the highlighted words of `title` in <span className="sm_accent">.
 */
const SiteSectionHead = ({ eyebrow, title, lead, text, align = "left", as: Title = "h2", titleClassName = "sm_title", className = "", children, ...rest }) => (
	<div className={`sm_head ${align === "center" ? "sm_head--center" : ""} ${className}`.trim()} {...rest}>
		{eyebrow && <p className="sm_eyebrow">{eyebrow}</p>}
		<Title className={titleClassName}>{title}</Title>
		{lead && <p className="sm_lead">{lead}</p>}
		{text && <p className="sm_body">{text}</p>}
		{children}
	</div>
);

export default SiteSectionHead;
